import BORapporter from '../../Bokning/Rapporter/BORapporter';
import BJRapporter from '../../BisattningJournal/Rapporter/BJRapporter';
import { IRapport } from './Delsystem';

export const rapporter: { [rtnKey: string]: IRapport } = {
  // ...LRRapporter,
  // ...ARRapporter,
  ...BORapporter,
  ...BJRapporter,
  // ...DIRapporter,
  // ...EKRapporter,
  // ...GARapporter,
  // ...KRRapporter,
  // ...MURapporter,
  // ...OFRapporter,
  // ...PURapporter,
  // ...SYSRapporter,
  // ...TIRapporter,
};
